import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit'
import { Container, Row, Col, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { resetAddedExtendedPackageResult } from '../../cellcomAbroadBlockSlice'
import images from '../images/images'
import { gaEvent } from '../../../../../utilities/analytics/tracking';
import gaParams from '../../../../../utilities/analytics/constants';
import './SuccessfulPackageInstall.scss'


export default function SuccessfulPackageInstall({ onClose, resetAddedExtendedPackageResult }) {

    const btnTxt = `חזרה לחו"ל שלי`;
    const header = `חבילת הגלישה <br /> !הותקנה בהצלחה`;
    const regTxt = `מיד תקבלו סמס שמאשר את הרכישה`;
    const boldTxt = `מוקד ${window.Config.brand_Name_HE} חו\"ל זמין 24\\7 <br /> בשיחת חינם גם מחו\"ל <br /> ${window.Config.numberCallCenterAbroad}`;

    useEffect(() => {
        gaEvent(gaParams.ABROAD_MY_ABROAD_SHOW_SUCCESSFUL_INSTALL_PACKAGE_POP_UP.category,
                gaParams.ABROAD_MY_ABROAD_SHOW_SUCCESSFUL_INSTALL_PACKAGE_POP_UP.eventType,
                gaParams.ABROAD_MY_ABROAD_SHOW_SUCCESSFUL_INSTALL_PACKAGE_POP_UP.eventParams)
        return () => {
            resetAddedExtendedPackageResult(null);
            onClose();
        }
    },[])

    function goBack() {
        gaEvent(gaParams.ABROAD_MY_ABROAD_CLICK_SUCCESSFUL_INSTALL_PACKAGE_POP_UP.category,
                gaParams.ABROAD_MY_ABROAD_CLICK_SUCCESSFUL_INSTALL_PACKAGE_POP_UP.eventType,
                gaParams.ABROAD_MY_ABROAD_CLICK_SUCCESSFUL_INSTALL_PACKAGE_POP_UP.eventParams)
        onClose();
    }

    return (
        <div className="SuccessfulPackageInstall-container">
            <div className="SuccessfulPackageInstall-header" dangerouslySetInnerHTML={{__html: header}}></div>
            <Image src={images.okDone} alt="ok" className="ok-img" />
            <div className="SuccessfulPackageInstall-data-box">
            <div className="data-box-reg" /*dangerouslySetInnerHTML={{__html: regTxt}}*/>{regTxt}</div>
                <div className="data-box-strong" dangerouslySetInnerHTML={{__html: boldTxt}}></div>
            </div>
            <BtnSubmit text={btnTxt} onclick={() => goBack()}/>
        </div>
    )
}
